/**
 * Design Token System
 *
 * Central export for all design tokens across the platform.
 * Import from here to access colors, typography, and status colors.
 *
 * @example
 * import { colors, typography } from '@/lib/theme';
 * <p style={{ ...typography.body.medium, color: colors.text.primary }}>
 */

export { colors,   } from './colors';
;

export { typography,   } from './typography';

;
;
